import type { SVGProps } from 'react';
export const GridMedium = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M8.13 2.5H5a1.25 1.25 0 0 0-1.25 1.25v12.5A1.25 1.25 0 0 0 5 17.5h3.13a1.25 1.25 0 0 0 1.24-1.25V3.75A1.25 1.25 0 0 0 8.14 2.5m0 13.75H5V3.75h3.13zM15 2.5h-3.12a1.25 1.25 0 0 0-1.26 1.25v12.5a1.25 1.25 0 0 0 1.26 1.25H15a1.25 1.25 0 0 0 1.25-1.25V3.75A1.25 1.25 0 0 0 15 2.5m0 13.75h-3.12V3.75H15z" />
  </svg>
);
